// AUTO-GENERATED FROM scripts/data/fito-shoes.csv.
// Run `node scripts/generate-fito-catalog.mjs` to regenerate.
// Do not edit by hand.

export type FitoFamily =
  | "Therapeutic Footwear"
  | "Post-Operative Footwear"
  | "Recovery Footwear";

export interface FitoProduct {
  family: FitoFamily;
  /** Internal SKU, e.g. "F1BK". */
  code: string;
  productName: string;
  description: string;
  /** Size labels in display order — e.g. "Size 38" or
   *  "Size 33-34 (ambidextrous)". */
  sizes: readonly string[];
  /** Filename inside apps/web/public/products/fito-shoes/. */
  image: string;
  /** Stable source URL on the manufacturer site — used by
   *  scripts/download-fito-images.mjs to (re)fetch the local image. */
  imageUrl: string;
  /** True when any size carries the "(ambidextrous)" suffix. Drives the
   *  per-modal info note about post-operative shoes fitting either foot. */
  hasAmbidextrous: boolean;
}

export const FITO_FAMILIES: readonly FitoFamily[] = [
  "Therapeutic Footwear",
  "Post-Operative Footwear",
  "Recovery Footwear",
];

export const FITO_PRODUCTS: readonly FitoProduct[] = [
  {
    family: "Therapeutic Footwear",
    code: "F1BK",
    productName: "F1BK - Fito Model 1 Black",
    description: "Therapeutic shoe with Rebalance® biomechanical sole and seamless Adaptive upper. Indicated for: diabetic foot, metatarsalgia, limited joint mobility, and neurological conditions requiring stability and gait guidance. Quick-lace system included; replaceable insole.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "F1BK.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_black_4.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Therapeutic Footwear",
    code: "F1GY",
    productName: "F1GY - Fito Model 1 Grey",
    description: "Therapeutic shoe with Rebalance® biomechanical sole and seamless Adaptive upper. Indicated for: diabetic foot, metatarsalgia, limited joint mobility, and neurological conditions requiring stability and gait guidance. Quick-lace system included; replaceable insole.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "F1GY.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_grey_4-1.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Therapeutic Footwear",
    code: "F1BU",
    productName: "F1BU - Fito Model 1 Blue",
    description: "Therapeutic shoe with Rebalance® biomechanical sole and seamless Adaptive upper. Indicated for: diabetic foot, metatarsalgia, limited joint mobility, and neurological conditions requiring stability and gait guidance. Quick-lace system included; replaceable insole.",
    sizes: [
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "F1BU.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_blue_4-1.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Therapeutic Footwear",
    code: "F1LI",
    productName: "F1LI - Fito Model 1 Lilac",
    description: "Therapeutic shoe with Rebalance® biomechanical sole and seamless Adaptive upper. Indicated for: diabetic foot, metatarsalgia, limited joint mobility, and neurological conditions requiring stability and gait guidance. Quick-lace system included; replaceable insole.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
    ],
    image: "F1LI.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_lilac_4.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Therapeutic Footwear",
    code: "FWAN",
    productName: "FWAN - Fito Model W Antracite",
    description: "Therapeutic shoe in WIDER fit (Calzata 14). NABUK Adaptive upper for thermal comfort. Indicated for: diabetic foot, metatarsal hyperpressure, gait instability, deformities needing extra room, edematous feet, fragile skin, and reduced lower-limb muscle tone.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "FWAN.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Wellwalking_winter-antracite_4.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Therapeutic Footwear",
    code: "FWSA",
    productName: "FWSA - Fito Model W Sand",
    description: "Therapeutic shoe in WIDER fit (Calzata 14). NABUK Adaptive upper for thermal comfort. Indicated for: diabetic foot, metatarsal hyperpressure, gait instability, deformities needing extra room, edematous feet, fragile skin, and reduced lower-limb muscle tone.",
    sizes: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "FWSA.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Wellwalking_winter-sand_4.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Post-Operative Footwear",
    code: "FFGY",
    productName: "FFGY - Fito Forefoot Grey",
    description: "Post-operative shoe with rigid Talismo 8° sole that transfers load from forefoot to rearfoot. Ambidextrous; fits a bandaged foot. Indicated for: forefoot fractures, inflammatory states, forefoot pain, interdigital and forefoot ulcers, and hallux valgus surgery recovery.",
    sizes: [
      "Size 33-34 (ambidextrous)",
      "Size 35-36 (ambidextrous)",
      "Size 37-38 (ambidextrous)",
      "Size 39-40 (ambidextrous)",
      "Size 41-42 (ambidextrous)",
      "Size 43-44 (ambidextrous)",
      "Size 45-46 (ambidextrous)",
    ],
    image: "FFGY.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_forefoot_3.jpg",
    hasAmbidextrous: true,
  },
  {
    family: "Post-Operative Footwear",
    code: "FMBK",
    productName: "FMBK - Fito Mesofoot Black",
    description: "Post-operative shoe with rigid biomechanical sole + Talismo 8° insole. Ambidextrous. Indicated for: hallux valgus post-surgery recovery, diabetic mesofoot/forefoot ulcers, and patients needing gait stability who want to reduce crutch dependence. Cuts re-ulceration risk 50%+.",
    sizes: [
      "Size 33-34 (ambidextrous)",
      "Size 35-36 (ambidextrous)",
      "Size 37-38 (ambidextrous)",
      "Size 39-40 (ambidextrous)",
      "Size 41-42 (ambidextrous)",
      "Size 43-44 (ambidextrous)",
      "Size 45-46 (ambidextrous)",
    ],
    image: "FMBK.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_mesofoot_3.jpg",
    hasAmbidextrous: true,
  },
  {
    family: "Post-Operative Footwear",
    code: "FALG",
    productName: "FALG - Fito Alux Light Grey",
    description: "Post-operative shoe with variable fit and rigid biomechanical sole. Ambidextrous; fits a bandaged foot. Indicated for: minimally invasive and percutaneous forefoot surgery, dorsal and interdigital ulcers, and patients with sensitive/fragile skin.",
    sizes: [
      "Size 33-34 (ambidextrous)",
      "Size 35-36 (ambidextrous)",
      "Size 37-38 (ambidextrous)",
      "Size 39-40 (ambidextrous)",
      "Size 41-42 (ambidextrous)",
      "Size 43-44 (ambidextrous)",
      "Size 45-46 (ambidextrous)",
    ],
    image: "FALG.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Fito_alux_3.jpg",
    hasAmbidextrous: true,
  },
  {
    family: "Recovery Footwear",
    code: "FHBK",
    productName: "FHBK - Fito Model H Black",
    description: "Recovery shoe with flexible Rebalance® sole and Adaptive upper for hand-free entry. Indicated for: rehabilitation, post-surgical recovery, joint instability, reduced mobility needing easy donning, and reducing impact stress on foot, ankle, knee and hip.",
    sizes: [
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
    ],
    image: "FHBK.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Wellwalking_home_black_4.jpg",
    hasAmbidextrous: false,
  },
  {
    family: "Recovery Footwear",
    code: "FOGY",
    productName: "FOGY - Fito Model Open Grey",
    description: "Recovery shoe (open variant) with flexible Rebalance® sole, hand-free entry. Indicated for: rehabilitation, post-surgical recovery, edematous feet, dressed/bandaged feet, and patients with limited mobility.",
    sizes: [
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
    ],
    image: "FOGY.jpg",
    imageUrl: "https://wellwalking.it/wp-content/uploads/Wellwalking_home_grey_open_4.jpg",
    hasAmbidextrous: false,
  },
];

export const FITO_IMAGE_BASE = '/products/fito-shoes';
